import { LogoText } from "../AscIcons";
import { ReactComponent as Logo } from "../../assets/illustrations/logo.svg";
import AscLink from "../AscLink/AscLink";

export interface AscLogoAdminProps {
  href?: string | null;
  condensed?: boolean;
  className?: string;
}

export default function AscLogoAdmin({
  href = "/",
  condensed,
  className,
}: AscLogoAdminProps) {
  const logo = condensed ? (
    <LogoText className={className} data-testid={"asc-logo-admin-condensed"} />
  ) : (
    <Logo className={className} data-testid={"asc-logo-admin"} />
  );

  if (href) {
    return <AscLink href={href}>{logo}</AscLink>;
  }
  return logo;
}
